/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespShippingReturns_shipmentQuote = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_shipmentQuote">;
    readonly " $refType": "PdpRespShippingReturns_shipmentQuote";
};
export type PdpRespShippingReturns_shipmentQuote$data = PdpRespShippingReturns_shipmentQuote;
export type PdpRespShippingReturns_shipmentQuote$key = {
    readonly " $data"?: PdpRespShippingReturns_shipmentQuote$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_shipmentQuote">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_shipmentQuote",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_shipmentQuote"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};
(node as any).hash = '4838708062e93030ab0806d9793b8fff';
export default node;
